<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-pagination
          v-model="currentPageData"
          class="my-4"
          :length="lastPage"
          @input="getPageNumber"
          circle
      ></v-pagination>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    lastPage: {
      type: Number,
      required: true
    }
  },
  methods: {
    getPageNumber: function (number) {
      if (this.currentPage === number) return
      this.$router.push({path: this.$route.fullPath, query: {page: number}})
    },
  },
  computed: {
    currentPageData: {
      get() {
        return this.currentPage
      },
      set(currentPage) {
        this.$emit('input', currentPage)
      }
    }
  }
}
</script>
